import { GeneralWebRTC, SinglePCAction } from "../webrtc/general_webrtc";
import { AudioDirection, CameraSpeakerAction, EventWebrtcAction, PresetWebrtcAction, SpeakerWebrtcAction, STREAM_TYPE_LIVE, STREAM_TYPE_PLAYBACK, STREAM_TYPE_TWO_WAY_AUDIO } from "../common/base";
import { ProgressWaiter } from "../common/timeout_waiter";
import { ControllerBase } from "./webrtc_controller";
import { CandidateType, OfferStatus, WebRTC } from "../webrtc/webrtc";
import { AppError } from "../common/app_error";
import { DataController } from "./data_controller";
import { DataWebRTC } from "../webrtc/data_webrtc";
import { DownloaderWebrtcAction } from "../common/downloader";
import { generateString } from "../common/util";
import { StreamWebRTC } from "../webrtc/stream_webrtc";
import { StreamController } from "./stream_controller";
export class GeneralController extends ControllerBase {
    constructor(options) {
        super(options, GeneralWebRTC);
        //allow manager to access streaming data
        this.streamInfos = [];
        this.sourceIdMapIdentify = new Map();
        // streamcontroller
        this.webRTC.addEventListener(StreamWebRTC.EVENT_TIME_UPDATE, (currentTime, sourceId) => {
            for (let streamInfo of this.streamInfos) {
                let progress = 0;
                if (streamInfo.sourceId == sourceId && streamInfo.streamType === STREAM_TYPE_PLAYBACK) {
                    let streamParams = streamInfo.parameter;
                    let diff = streamParams.endAt - streamParams.startAt;
                    if (diff !== 0) {
                        progress = currentTime / diff;
                        if (progress < 0)
                            progress = 0;
                        else if (progress > 1)
                            progress = 1;
                    }
                    this.emitEvent(StreamController.EVENT_TIME_PROGRESS, currentTime, progress, streamInfo.sourceId);
                    break;
                }
            }
        });
        // datacontroller
        this.waiter = new ProgressWaiter("GeneralController", DataController.SEND_TIMEOUT, options.debugging);
        this.webRTC.addEventListener(DataWebRTC.EVENT_DEVICE_SNAPSHOTS, (snapshot) => {
            if (this.debugging)
                console.debug("event_device_snapshots: snapshot=%s", JSON.stringify(snapshot));
            this.onEventSnapshot(snapshot);
        });
    }
    getUniqueSourceId(parameter, streamType) {
        const sourceIdInner = this.getUniqueSourceIdInner(parameter, streamType);
        let idendification = this.sourceIdMapIdentify.get(sourceIdInner);
        if (idendification) {
            if (idendification.exist) {
                return `${sourceIdInner}-${idendification.times}`;
            }
            else {
                idendification.exist = true;
                this.sourceIdMapIdentify.set(sourceIdInner, idendification);
                return `${sourceIdInner}-${++idendification.times}`;
            }
        }
        else {
            this.sourceIdMapIdentify.set(sourceIdInner, { times: 0, exist: true });
            return `${sourceIdInner}-0`;
        }
    }
    getUniqueSourceIdInner(parameter, streamType) {
        if (streamType === STREAM_TYPE_LIVE) {
            let streamParam = parameter;
            return `${streamParam.cameraMac.replace(/:/g, '')}-${streamParam.remoteIndex}-${streamParam.streamId}-${this.connectId}`;
        }
        else if (streamType === STREAM_TYPE_PLAYBACK) {
            let streamParam = parameter;
            return `${streamParam.cameraMac.replace(/:/g, '')}-${streamParam.remoteIndex}${streamParam.streamId}-${streamParam.startAt}-${streamParam.endAt}-${this.connectId}`;
        }
        else if (streamType === STREAM_TYPE_TWO_WAY_AUDIO) {
            let streamParam = parameter;
            return `${streamParam.macAddress.replace(/:/g, '')}-${streamParam.remoteIndex}-${this.connectId}`;
        }
    }
    removeSourceIdsInner(sourceIds) {
        for (let id of sourceIds) {
            let index = id.lastIndexOf('-');
            if (index == -1) {
                console.error(`Invalid sourceId: ${id}`);
                this.webRTC.emitEvent(GeneralWebRTC.EVENT_ERROR, new AppError({ name: SinglePCAction.StreamRemove, message: `Invalid sourceId: ${id}`, code: -1, external: [id] }));
                continue;
            }
            let sourceIdInner = id.substring(0, index);
            let idendification = this.sourceIdMapIdentify.get(sourceIdInner);
            if (idendification) {
                idendification.exist = false;
            }
            else {
                console.warn(`Not added sourceId: ${id}`);
            }
        }
    }
    addStreamSetting(setting) {
        let streamInfo = {
            sourceId: this.getUniqueSourceId(setting.parameter, setting.streamType),
            parameter: setting.parameter,
            streamType: setting.streamType,
            video: setting.video,
            audio: setting.audio,
            canvas: setting.canvas,
            outerCb: setting.outerCb
        };
        if (this.streamInfos.find((item) => item.sourceId === streamInfo.sourceId)) {
            console.warn(`Duplicate sourceId: ${streamInfo.sourceId}`);
            this.webRTC.emitEvent(GeneralWebRTC.EVENT_ERROR, new AppError({ name: SinglePCAction.StreamAdd, message: `Dulplicate  sourceId: ${streamInfo.sourceId}`, code: -1, external: [streamInfo.sourceId] }));
            return null;
        }
        this.streamInfos.push(streamInfo);
        return streamInfo;
    }
    startV2(settings, outerCb) {
        let mediaSetting = [];
        for (let setting of settings) {
            let streamInfo = this.addStreamSetting(setting);
            if (!streamInfo) {
                continue;
            }
            let media = {
                streamId: streamInfo.sourceId,
                audio: streamInfo.audio,
                canvas: streamInfo.canvas,
                setting
            };
            if (setting.streamType == STREAM_TYPE_LIVE) {
                media.audioDirection = AudioDirection.recvonly;
                media.video = setting.parameter.videoInfo;
            }
            else if (setting.streamType == STREAM_TYPE_PLAYBACK) {
                media.audioDirection = AudioDirection.recvonly;
                media.video = setting.parameter.videoInfo;
            }
            else if (setting.streamType == STREAM_TYPE_TWO_WAY_AUDIO) {
                if (setting.video) {
                    throw new Error('Two way audio should not have video');
                }
                media.video = null;
                media.audioDirection = AudioDirection.sendrecv;
            }
            mediaSetting.push(media);
        }
        outerCb?.(mediaSetting);
        const starting = this.webRTC.startBatch(mediaSetting);
        if (starting) {
            this.connecting = true;
            setTimeout(() => {
                if (this.connecting) {
                    this.emitClose(ControllerBase.CLOSE_TIMEOUT);
                }
            }, ControllerBase.CONNECT_TIMEOUT);
        }
        return starting;
    }
    addSources(settings, outerCb) {
        // failedStreamInfos will trigger reconnect if not bandwidth limit 
        // successfulStreamInfos will set sourceId into manager 
        // any other error not in failedStreamInfos should trigger webRTC reconnect 
        let failedStreamInfos = [];
        let successfulStreamInfos = [];
        let lamda = (func) => {
            let sInfos = [];
            for (let setting of settings) {
                setting.outerCb = outerCb;
                if (this.closed) {
                    //@ts-ignore
                    failedStreamInfos.push({ ...setting, reason: 'controller closed', success: false });
                    continue;
                }
                let streamInfo = this.addStreamSetting(setting);
                if (!streamInfo) {
                    outerCb({ streamInfo, success: false, reason: new AppError({ name: "duplicate", message: "Duplicate StreamId" }) });
                    continue;
                }
                try {
                    let error;
                    if (setting.streamType == STREAM_TYPE_TWO_WAY_AUDIO) {
                        error = this.webRTC.addStream({ streamId: streamInfo.sourceId, audio: streamInfo.audio, video: null, audioDirection: AudioDirection.sendrecv, canvas: null });
                    }
                    else if (setting.streamType == STREAM_TYPE_LIVE) {
                        error = this.webRTC.addStream({ streamId: streamInfo.sourceId, audio: streamInfo.audio, video: setting.parameter.videoInfo, audioDirection: AudioDirection.recvonly, canvas: setting.canvas });
                    }
                    else if (setting.streamType == STREAM_TYPE_PLAYBACK) {
                        error = this.webRTC.addStream({ streamId: streamInfo.sourceId, audio: streamInfo.audio, video: setting.parameter.videoInfo, audioDirection: AudioDirection.recvonly, canvas: setting.canvas });
                    }
                    if (error) {
                        failedStreamInfos.push({ ...streamInfo, reason: error, success: false });
                        continue;
                    }
                    sInfos.push(streamInfo);
                }
                catch (error) {
                    console.error('addStream error:', error);
                    failedStreamInfos.push({ ...streamInfo, reason: error.message, success: false });
                }
            }
            if (sInfos.length == 0) {
                func(failedStreamInfos, []);
                return;
            }
            this.webRTC.createOffer(OfferStatus.Add).then((sdp) => {
                this.webRTC.addStreamsAction(sInfos, sdp, func, failedStreamInfos, successfulStreamInfos);
            }).catch((error) => {
                console.error('createOffer error:', error);
                func(failedStreamInfos, successfulStreamInfos);
            });
        };
        let callback = (failedStreamInfos, successfulStreamInfos) => {
            console.log('failedSourceIds:', failedStreamInfos);
            console.log('successfulStreamInfos:', successfulStreamInfos);
            const sourceIds = failedStreamInfos.map(item => item.sourceId).filter(value => value);
            // this remove must be succeeded to current add operation
            this.webRTC.getEventQueue().enqueueToHead((func) => {
                try {
                    successfulStreamInfos.forEach(successfulItem => outerCb({ streamInfo: successfulItem, success: true }));
                    failedStreamInfos.forEach(failedItem => {
                        outerCb({ streamInfo: failedItem, success: false, reason: failedItem.reason });
                    });
                    func();
                }
                catch (e) {
                    console.info(e);
                    func();
                }
            });
            this.webRTC.getEventQueue().enqueueToHead((func) => {
                this.removeSourcesInner(sourceIds, func);
            });
        };
        this.webRTC.getEventQueue().enqueue(lamda, callback);
    }
    //for manager use, remove all sources with same sourceIdInner
    async removeWithSourceIdInner(sourceIdInner) {
        const matchStreamInfos = this.streamInfos.filter((item) => {
            const sourceId = item.sourceId;
            const lastIndex = sourceId.lastIndexOf("-");
            const secondLastIndex = sourceId.lastIndexOf("-", lastIndex - 1);
            return sourceId.substring(0, secondLastIndex) === sourceIdInner;
        });
        console.log("removing sources", matchStreamInfos);
        this.removeSources(matchStreamInfos.map(item => item.sourceId));
    }
    async removeSources(sources) {
        let sourceIds = [];
        for (let source of sources) {
            let sId;
            if (typeof source === 'string') {
                sId = source;
            }
            else {
                sId = this.getUniqueSourceId(source.parameter, source.streamType);
            }
            sourceIds.push(sId);
        }
        this.webRTC.getEventQueue().enqueue((func) => {
            this.removeSourcesInner(sourceIds, func);
        });
    }
    removeSourcesInner(sourceIds, cb) {
        if (sourceIds.length == 0) {
            cb();
            return;
        }
        let inner = (err, _result) => {
            if (err) {
                this.webRTC.emitEvent(WebRTC.EVENT_ERROR, err);
            }
            else {
                this.webRTC.emitEvent(SinglePCAction.StreamRemove, { code: 0, data: sourceIds });
            }
            cb();
        };
        // remove sourceIds in advance
        this.removeSourceIdsInner(sourceIds);
        this.streamInfos = this.streamInfos.filter((item) => !sourceIds.includes(item.sourceId));
        this.webRTC.removeStreams(sourceIds, inner);
    }
    async doOnAnswer(reply) {
        const failedSourceIds = await this.webRTC.onAnswer(reply.streamResults, this.streamInfos, reply.answer);
        if (failedSourceIds.length > 0) {
            this.webRTC.getEventQueue().enqueue((cb) => {
                this.removeSourcesInner(failedSourceIds, cb);
            });
            this.webRTC.emitEvent(WebRTC.EVENT_ERROR, new AppError({ name: SinglePCAction.StreamAdd, message: 'Stream add error', code: -1, external: failedSourceIds }));
        }
    }
    sendOffer(offer, traceHeader) {
        let offerObj = {
            orgId: this.orgId, connectId: this.connectId, turn: this.turn,
            rtcToken: this.rtcToken, offer: offer.sdp,
            traceHeader
        };
        let streamTypes = [];
        this.streamInfos.forEach(value => {
            if (value.streamType === STREAM_TYPE_LIVE) {
                streamTypes.push({ streamParam: value.parameter, sourceId: value.sourceId });
            }
            else if (value.streamType === STREAM_TYPE_PLAYBACK) {
                streamTypes.push({ playbackParam: value.parameter, sourceId: value.sourceId });
            }
            else if (value.streamType === STREAM_TYPE_TWO_WAY_AUDIO) {
                streamTypes.push({ twoWayAudio: value.parameter, sourceId: value.sourceId });
            }
        });
        this.signal.sendBatchOffer(this, offerObj, streamTypes, this.webRTC.getSelectedVideoCodec());
    }
    doGetDesc() {
        return { connectId: this.connectId, nvrId: this.nvrId, streamInfos: this.streamInfos };
    }
    openAudio(params, token, callback) {
        let twoWayAudioParams = { macAddress: params.macAddress, token, sourceId: this.getUniqueSourceId(params, STREAM_TYPE_TWO_WAY_AUDIO), remoteIndex: params.remoteIndex };
        let action = SpeakerWebrtcAction.SPEAK;
        if (params.deviceType == GeneralController.CAMERA_AUDIO) {
            action = CameraSpeakerAction.SPEAK;
        }
        const error = this.webRTC.speakControl(twoWayAudioParams, action, callback);
        if (error && callback)
            callback(AppError.fromError(error), null);
    }
    async getCandidateType() {
        if (this.webRTC.getCandidateType() === CandidateType.None) {
            await this.webRTC.checkCandidateType();
        }
        return this.webRTC.getCandidateType();
    }
    releaseDevice(sourceId, kind) {
        this.webRTC.releaseDevice(sourceId, kind);
    }
    // datacontroller start
    onEventSnapshot(snapshot) {
        const completing = (context) => {
            let done = false;
            let callbackObject = null;
            const camera = snapshot.camera;
            const key = camera.macAddress + camera.remoteIndex;
            if (context.reqCameras.has(key)) {
                context.resCameras.set(key, snapshot);
            }
            else {
                console.error("onEventSnapshot:: res camera not in reqCameras: key=%s", key);
            }
            // completed
            if (context.reqCameras.size == context.resCameras.size) {
                done = true;
                let error = null;
                const cameras = [];
                context.reqCameras.forEach((camera, key) => {
                    const cameraUnit = context.resCameras.get(key);
                    cameras.push(cameraUnit);
                    if (cameraUnit.error) {
                        error = cameraUnit.error;
                    }
                });
                callbackObject = { error, result: { cameras } };
            }
            return { done, callbackObject };
        };
        this.waiter.resetTimeout({ id: snapshot.actId, completing });
    }
    onDeviceTakeSnapshots(id, error, actRes) {
        const completing = (context) => {
            let result = null, done = false;
            let callbackObject = null;
            if (error) {
                // all failed
                done = true;
                result = { cameras: [] };
                context.reqCameras.forEach((camera) => {
                    result.cameras.push({ camera, error });
                });
                callbackObject = { error, result };
            }
            else {
                // some might fail
                const camerasRes = actRes.data.snapshotResult;
                camerasRes.forEach((item) => {
                    // care about errored camera only
                    if (item.error) {
                        const camera = item.camera;
                        const key = camera.macAddress + camera.remoteIndex;
                        if (context.reqCameras.has(key))
                            context.resCameras.set(key, { error: AppError.fromObject(item.error), camera });
                        else
                            console.error("onDeviceTakeSnapshots:: res camera not in reqCameras: key=%s", key);
                    }
                });
                if (context.reqCameras.size == context.resCameras.size) {
                    // all cameras failed
                    done = true;
                    const cameras = [];
                    context.reqCameras.forEach((camera, key) => {
                        cameras.push(context.resCameras.get(key));
                    });
                    result = { cameras };
                    callbackObject = { error: AppError.unknownError({ desc: "all cameras failed" }), result };
                }
            }
            return { done, callbackObject };
        };
        this.waiter.resetTimeout({ id, completing });
    }
    doDeviceTakeSnapshots(cameras, callback) {
        let e = null;
        if (this.webRTC.isConnected()) {
            const actId = generateString(31);
            const timeout = DataController.SEND_TIMEOUT + 1000 * cameras.length;
            this.stats.start({ key: DataController.STATS_DEVICE_SNAPSHOT_WS });
            e = this.signal.deviceTakeSnapshots({
                actId,
                orgId: this.orgId,
                nvrId: this.nvrId,
                connectId: this.connectId,
                cameras: cameras,
                timeout,
            }, (error, actRes) => {
                this.stats.end({ key: DataController.STATS_DEVICE_SNAPSHOT_WS, message: { error } });
                this.onDeviceTakeSnapshots(actId, error, actRes);
            });
            if (!e) {
                const timeoutCallback = (appError, context) => {
                    const cameras = [];
                    context.reqCameras.forEach((camera, key) => {
                        const resCamera = context.resCameras.get(key);
                        let cameraUnit;
                        if (resCamera === undefined) {
                            cameraUnit = { error: appError, camera };
                        }
                        else {
                            cameraUnit = resCamera;
                        }
                        cameras.push(cameraUnit);
                    });
                    if (callback) {
                        // completed
                        callback(appError, { cameras });
                    }
                };
                const context = {
                    reqCameras: new Map(),
                    resCameras: new Map(),
                };
                cameras.forEach((camera) => {
                    context.reqCameras.set(camera.macAddress + camera.remoteIndex, camera);
                });
                this.waiter.setTimeout({ id: actId, callback, context, timeoutCallback, timeout }, "doDeviceTakeSnapshots");
            }
        }
        else {
            e = AppError.webrtcDisconnectedError();
        }
        if (e && callback) {
            // all failed
            callback(e, {
                cameras: cameras.map((camera) => {
                    return { camera, error: e };
                }),
            });
        }
    }
    /*
     * There is no error when all succeed, but the error is set when at least one fails.
     * Each camera item (result.cameras[*]) in the callback contains error indicating whether it fails or not.
     * The result field in the callback cannot be null.
     * The result.cameras in the callback has the same order as the argument of cameras.
     */
    deviceTakeSnapshots(cameras, callback) {
        cameras.forEach((camera) => {
            this.stats.start({ key: DataController.STATS_DEVICE_SNAPSHOT + this.getCameraKey(camera) });
        });
        // result cannot be null
        this.doDeviceTakeSnapshots(cameras, (error, result) => {
            result?.cameras.forEach((cameraUnit) => {
                this.stats.end({
                    key: DataController.STATS_DEVICE_SNAPSHOT + this.getCameraKey(cameraUnit.camera),
                    message: { error: cameraUnit.error },
                });
            });
            if (callback)
                callback(error, result);
        });
    }
    //get dailyRecord for a month
    recordDaily(req, callback, timeout) {
        const stats = this.stats;
        const key = DownloaderWebrtcAction.RecordDaily;
        stats.start({ key: key, message: req });
        return this.webRTC.recordDaily(req, function (e, msg) {
            stats.end({ key: key, message: { error: e, msg: msg } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const rsp = {
                camera: msg.data["camera"],
                streamId: msg.data["streamId"], // 0: HD stream,1:SD stream
                recordDailyList: msg.data["recordDailyList"]
            };
            callback?.(null, rsp);
        }, timeout);
    }
    //get file generation status :generating/generated/failed
    downloaderList(req, callback, timeout) {
        const stats = this.stats;
        const key = DownloaderWebrtcAction.List;
        stats.start({ key: key, message: req });
        return this.webRTC.downloaderList(req, function (e, msg) {
            stats.end({ key: key, message: { error: e, msg: msg } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const rsp = {
                records: msg.data["records"],
                quota: msg.data["quota"]
            };
            callback?.(null, rsp);
        }, timeout);
    }
    videoDownload(req, callback, timeout) {
        if (req.speed > 1024) {
            return new Error("Download speed should less than 1024.");
        }
        req.content.range = "bytes=" + req.content.ranges.start + "-" + req.content.ranges.end;
        if (!timeout) {
            const chunkSize = req.content.ranges.end - req.content.ranges.start;
            timeout = Math.ceil(chunkSize / (req.speed * 1024)) * 1000;
            console.debug('videoDownload timeout', timeout);
        }
        console.debug('videoDownload range', req.content.range);
        const stats = this.stats;
        const key = DownloaderWebrtcAction.Download + ": " + req.camera.id + " " + req.content.range;
        stats.start({ key: key, message: req });
        return this.webRTC.downloadVideo(req, function (e, msg) {
            stats.end({ key: key, message: { error: e } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const rsp = {
                downloaderId: msg.data["downloaderId"],
                actorId: msg.data["actorId"],
                recordId: msg.data["recordId"],
                camera: msg.data["camera"],
                content: msg.data["content"],
                sentAt: msg.data["sentAt"],
                payload: msg.obj.binary,
            };
            callback?.(null, rsp);
        }, timeout);
    }
    videoAbort(req, callback) {
        const stats = this.stats;
        const key = DownloaderWebrtcAction.Abort + ": " + req.camera.id;
        stats.start({ key: key, message: req });
        return this.webRTC.abortVideo(req, function (e, msg) {
            stats.end({ key: key, message: { error: e, msg: msg } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const rsp = {
                downloaderId: msg.data["downloaderId"],
                actorId: msg.data["actorId"],
                recordId: msg.data["recordId"],
                camera: msg.data["camera"],
            };
            callback?.(e, rsp);
        });
    }
    videoComplete(req, callback) {
        const stats = this.stats;
        const key = DownloaderWebrtcAction.Complete + ": " + req.camera.id;
        this.stats.start({ key: key, message: req });
        return this.webRTC.completeVideo(req, function (e, msg) {
            stats.end({ key: key, message: { error: e, msg: msg } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const rsp = {
                downloaderId: msg.data["downloaderId"],
                actorId: msg.data["actorId"],
                recordId: msg.data["recordId"],
                camera: msg.data["camera"],
            };
            callback?.(e, rsp);
        });
    }
    getCameraKey(camera) {
        let key = "[";
        if (typeof camera.id === "number") {
            key += "id=" + camera.id + ", ";
        }
        key += "macAddress=" + camera.macAddress + ", ";
        key += "remoteIndex=" + camera.remoteIndex + "]";
        return key;
    }
    presetList(req, callback) {
        const stats = this.stats;
        const key = PresetWebrtcAction.LIST + ": " + req.camera.id;
        this.stats.start({ key: key, message: req });
        return this.webRTC.presetList(req, function (e, msg) {
            stats.end({ key: key, message: { error: e, msg: msg } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const res = { presetList: [] };
            const presetList = [];
            msg.data?.presetList?.presetInfos?.forEach((preset) => {
                preset && presetList.push({ id: preset?.id, name: preset?.name, modifiedAt: preset?.modifiedAt });
            });
            res.presetList = presetList;
            callback?.(e, res);
        });
    }
    presetSet(req, callback) {
        const stats = this.stats;
        const key = PresetWebrtcAction.SET + ": " + req.camera.id;
        this.stats.start({ key: key, message: req });
        return this.webRTC.presetSet(req, function (e, msg) {
            stats.end({ key: key, message: { error: e, msg: msg } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const res = {
                ok: msg.data?.ok,
            };
            callback?.(e, res);
        });
    }
    presetDelete(req, callback) {
        const stats = this.stats;
        const key = PresetWebrtcAction.DELETE + ": " + req.camera.id;
        this.stats.start({ key: key, message: req });
        return this.webRTC.presetDelete(req, function (e, msg) {
            stats.end({ key: key, message: { error: e, msg: msg } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const res = {
                ok: msg.data?.ok,
            };
            callback?.(e, res);
        });
    }
    presetGoto(req, callback) {
        const stats = this.stats;
        const key = PresetWebrtcAction.GOTO + ": " + req.camera.id;
        this.stats.start({ key: key, message: req });
        return this.webRTC.presetGoto(req, function (e, msg) {
            stats.end({ key: key, message: { error: e, msg: msg } });
            if (e) {
                callback?.(e, null);
                return;
            }
            const res = {
                ok: msg.data?.ok,
            };
            callback?.(e, res);
        });
    }
    presetGetImg(req, callback, timeout) {
        const stats = this.stats;
        const key = PresetWebrtcAction.GET_IMG + ": " + req.camera.id;
        this.stats.start({ key: key, message: req });
        return this.webRTC.presetGetImg(req, (error, msg) => {
            stats.end({ key: key, message: { error: error, msg: msg } });
            callback?.(error, msg);
        }, timeout);
    }
    speakerPlay(param, callback) {
        let audioLive = { macAddress: param.macAddress };
        return this.webRTC.speakerPlay({ ...param, sourceId: this.getUniqueSourceId(audioLive, STREAM_TYPE_TWO_WAY_AUDIO) }, callback);
    }
    getMediaImg(req, callback) {
        const stats = this.stats;
        const key = EventWebrtcAction.GetMedia + ": " + req.eventId;
        this.stats.start({ key: key, message: req });
        return this.webRTC.getMediaImg(req, (error, msg) => {
            stats.end({ key: key, message: { error: error, msg: msg } });
            callback?.(error, msg);
        });
    }
    play(sources, options) { return {}; }
    // datacontroller end
    pause(arg1, arg2, arg3) {
        if (typeof arg1 === 'string') {
            this.webRTC.pause(arg1, arg2);
        }
        else if (arg2 !== undefined) {
            this.webRTC.pause(this.getUniqueSourceId(arg1, arg2), arg3);
        }
        else {
            throw new Error('Invalid arguments for pause method');
        }
    }
    // 实现 resume 函数
    resume(arg1, arg2, arg3) {
        if (typeof arg1 === 'string') {
            this.webRTC.resume(arg1, arg2);
        }
        else if (arg2 !== undefined) {
            this.webRTC.resume(this.getUniqueSourceId(arg1, arg2), arg3);
        }
        else {
            throw new Error('Invalid arguments for resume method');
        }
    }
    // 实现 seek 函数
    seek(seek, arg1, arg2, arg3) {
        if (typeof arg1 === 'string') {
            this.webRTC.seek(seek, arg1, arg2);
        }
        else if (arg2 !== undefined) {
            this.webRTC.seek(seek, this.getUniqueSourceId(arg1, arg2), arg3);
        }
        else {
            throw new Error('Invalid arguments for seek method');
        }
    }
    // 实现 scale 函数
    scale(scale, arg1, arg2) {
        if (typeof arg1 === 'string') {
            this.webRTC.scale(scale, arg1);
        }
        else if (arg2 !== undefined) {
            this.webRTC.scale(scale, this.getUniqueSourceId(arg1, arg2));
        }
        else {
            throw new Error('Invalid arguments for scale method');
        }
    }
    // 实现 speed 函数
    speed(speed, arg1, arg2, arg3) {
        if (typeof arg1 === 'string') {
            this.webRTC.speed(speed, arg1, arg2);
        }
        else if (arg2 !== undefined && typeof arg2 !== 'function') {
            this.webRTC.speed(speed, this.getUniqueSourceId(arg1, arg2), arg3);
        }
        else {
            throw new Error('Invalid arguments for speed method');
        }
    }
    ptz(param) {
        this.webRTC.ptz(param);
    }
    speakerConfigGet(token, macAddress, callback) {
        return this.webRTC.speakerConfigGet(token, macAddress, callback);
    }
    speakerConfigSet(token, macAddress, audioParams, callback) {
        return this.webRTC.speakerConfigSet(token, macAddress, audioParams, callback);
    }
    cameraSpeakerConfigGet(token, macAddress, remoteIndex, callback) {
        return this.webRTC.cameraSpeakerConfigGet(token, macAddress, remoteIndex, callback);
    }
    cameraSpeakerConfigSet(token, macAddress, remoteIndex, audioParams, callback) {
        return this.webRTC.cameraSpeakerConfigSet(token, macAddress, remoteIndex, audioParams, callback);
    }
}
//device
GeneralController.CAMERA_AUDIO = 'ip_camera';
